import { Component } from '@angular/core';

@Component({
  selector: 'app-hr-details-link',
  templateUrl: './hr-details-link.component.html',
  styleUrls: ['./hr-details-link.component.scss']
})
export class HrDetailsLinkComponent {

}
